import React from 'react';
import { IconButton, IconProps, useTheme } from '@mui/material';
import { Svgs } from '../assets/svg';

interface ExpandIconProps extends IconProps {
  isExpanded: boolean;
  onToggle: () => void;
}

const ExpandIcon: React.FC<ExpandIconProps> = ({ isExpanded, onToggle, color, sx }) => {
  const theme = useTheme();

  return (
    <IconButton
      onClick={e => {
        e.stopPropagation();
        onToggle();
      }}
      sx={{ cursor: 'pointer', ...sx }}>
      {isExpanded ? (
        <Svgs.IconCollapse fill={color || theme.palette.info.main} />
      ) : (
        <Svgs.IconAdd fill={color || theme.palette.info.main} />
      )}
    </IconButton>
  );
};

export default ExpandIcon;
